import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5),
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};
